module.exports = __webpack_public_path__ + "static/img/14000687.57f9e96d.png";